// extracted by mini-css-extract-plugin
export var createdDate = "_o4-1";
export var divider = "_o4-2";
export var headerDivider = "_o4-3";
export var messagesCard = "_o4-0";
export var messagesContainer = "_o4-6";
export var messagesContainerWrapper = "_o4-4";
export var showLeftPanelButton = "_o4-8";
export var topButtons = "_o4-7";
export var withPadding = "_o4-5";